import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "row col-xs-12 justify-center" }
const _hoisted_2 = { class: "row justify-end q-mt-md" }

import { computed, reactive, ref } from 'vue';
import {
  getErrorCode,
  getErrorDetailMessageOrDefault,
  parseJwt,
} from '@packages/toolbox/dist/utils/http-handle';
import { HTTP_CODE_ERROR } from '@packages/toolbox/dist/constants/http-codes';
import getUserFingerprint from '@packages/toolbox/dist/utils/fingerprint';
import { checkCurrentProfile } from 'boot/middleware';
import LoginForm from 'components/Auth/LoginForm.vue';
import { useBanner } from 'SharedComponents/base/Banner/useBanner';
import { useLoading } from 'SharedDir/common/composables/useLoading';
import { useNotifications } from 'SharedDir/common/composables/useNotifications';
import { makeRequest } from 'SharedDir/common/composables/useRequests';
import { useAuthStore } from 'SharedDir/stores/auth.store';
import { useUserStore } from 'SharedDir/stores/user.store';
import { useAppStore } from 'stores/app';
import PortalDialog from 'components/base/PortalDialog.vue';
import AccessApi from 'SharedDir/backend/api/classes/access.api';
import SBtnEsia from '@app/shared/src/components/ui/Button/SBtnEsia.vue';
import { useRoute, useRouter } from 'vue-router';
import { useNotificationStore } from 'SharedDir/stores/notification.store';
import { FeatureFlagName } from 'SharedDir/declarations/system/region-customization';
import { useFeatureFlags } from 'SharedDir/common/composables/useFeatureFlags';


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'LoginDialog' },
  __name: 'LoginDialog',
  setup(__props) {



const { banner, hideBanner, showBanner } = useBanner();
const { action } = useLoading();
const route = useRoute();
const router = useRouter();
const { warningNotification } = useNotifications();
const [appStore, authStore, userStore, notificationStore] = [
  useAppStore(),
  useAuthStore(),
  useUserStore(),
  useNotificationStore(),
];
const { getFeatureFlag } = useFeatureFlags();

const requestOptions = {
  startLoading: action.show,
  finishLoading: action.hide,
};
const loading = computed(() => action.state.value);

const show = computed({
  get: () => appStore.authDialogShow,
  set: (value: boolean) => {
    appStore.setAuthDialog(value);
  },
});

const pattern = getFeatureFlag(FeatureFlagName.IsVisiblePatternInModalPortal);

const credentials = ref({
  login: '',
  password: '',
});
const refLoginForm = ref<typeof LoginForm>(null as any);

function loginViaEsia() {
  makeRequest(async () => {
    const response = await AccessApi.getEsiaRedirectAuthUrl();
    if (response?.url) {
      window.location.href = response.url;
    }
  }, requestOptions);
}

async function auth() {
  const isValidForm: boolean = await refLoginForm.value.validate();
  if (!isValidForm) {
    warningNotification('Необходимо заполнить обязательные поля');
    return;
  }

  const data = {
    fingerprint: await getUserFingerprint(),
    isPortal: true,
    ...credentials.value,
  };

  await makeRequest(async () => {
    const { token, user, userProfiles } = await AccessApi.login(data);
    const { redirectTo } = route.query;
    const parsedRefreshToken = parseJwt(token)?.refresh_token ?? null;
    authStore.setRefreshToken(parsedRefreshToken);
    authStore.setToken(token);
    userStore.setUser(user);
    await userStore.setUserProfiles({ profiles: userProfiles });
    if (redirectTo && typeof redirectTo === 'string') {
      await router.push(redirectTo as string);
    }
    show.value = false;
    if (!checkCurrentProfile(userStore)) {
      appStore.showProfileDialog();
    }
    notificationStore.fetchUnreadNotifications();

    hideBanner();
  }, requestOptions);
}

return (_ctx: any,_cache: any) => {
  const _component_s_btn = _resolveComponent("s-btn")!
  const _component_q_no_ssr = _resolveComponent("q-no-ssr")!
  const _component_s_banner = _resolveComponent("s-banner")!

  return (_openBlock(), _createBlock(PortalDialog, {
    modelValue: show.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((show).value = $event)),
    title: "Вход в личный кабинет",
    pattern: _unref(pattern),
    info: ""
  }, {
    default: _withCtx(() => [
      _createVNode(LoginForm, {
        ref_key: "refLoginForm",
        ref: refLoginForm,
        modelValue: credentials.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((credentials).value = $event)),
        onSubmit: auth
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_q_no_ssr, null, {
              default: _withCtx(() => [
                _createVNode(_component_s_btn, {
                  class: "full-width q-mt-md",
                  type: "brand",
                  fat: "",
                  loading: loading.value,
                  onClick: auth
                }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode(" Войти ")
                  ])),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            }),
            (_unref(banner).visibility)
              ? (_openBlock(), _createBlock(_component_s_banner, {
                  key: 0,
                  class: "q-mt-md",
                  type: _unref(banner).type,
                  "with-icon": ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(banner).text), 1)
                  ]),
                  _: 1
                }, 8, ["type"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(SBtnEsia, {
              fat: "",
              loading: loading.value,
              onClick: loginViaEsia
            }, null, 8, ["loading"])
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["modelValue", "pattern"]))
}
}

})